import dayjs from 'dayjs';

/** « 1 pièce », « 1 250 pièces » ; pluriel irrégulier en troisième argument. */
export const pluriel = (
	nombre: number,
	singulier: string,
	plurielle = `${singulier}s`,
) => `${nombre.toLocaleString('fr-FR')} ${nombre > 1 ? plurielle : singulier}`;

/** Taille d'un fichier en Ko (1 au moins) ou en Mo. */
export const taille = (octets: number) =>
	octets < 1024 * 1024
		? `${Math.max(1, Math.round(octets / 1024))} Ko`
		: `${(octets / 1024 / 1024).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} Mo`;

/** Date (Y-m-d) en jj/mm/aaaa ; vide si absente. */
export const dateCourte = (date: string | null) =>
	date ? dayjs(date).format('DD/MM/YYYY') : '';

/** Texte comparable à une saisie : minuscules et sans accents (« Référence » comme « reference »). */
export const normaliser = (texte: string) =>
	texte
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLocaleLowerCase('fr');
